import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/core/useAuth";
import { Loader } from "@mantine/core";

export function PublicRoute({ children }) {
  const { user, staffProfile, isLoading, error } = useAuth();
  const location = useLocation();

  // Debug logging
  if (import.meta.env.DEV) {
    console.log("[PublicRoute] Auth state:", {
      hasUser: !!user,
      userId: user?.uid,
      hasStaffProfile: !!staffProfile,
      isLoading,
      error: error?.message,
    });
  }

  // Only redirect if we're definitely authenticated (not just loading)
  if (!isLoading && user && staffProfile) {
    // Use location state if available, otherwise fallback to root
    const to = location.state?.from?.pathname || sessionStorage.getItem("returnTo") || "/";
    if (import.meta.env.DEV) {
      console.log("[PublicRoute] Redirecting authenticated user to:", to);
    }
    sessionStorage.removeItem("returnTo");
    return <Navigate to={to} replace={false} />;
  }

  // Show loading state while checking auth
  if (isLoading) {
    return (
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          fontSize: "1.2em",
        }}
      >
        <Loader color="blue" size="xl" type="bars" />
      </div>
    );
  }

  // If user exists but staff profile doesn't, show helpful error
  if (!isLoading && user && !staffProfile) {
    console.error("[PublicRoute] User authenticated but staff profile missing:", {
      userId: user.uid,
      email: user.email,
      expectedPath: `/staff/${user.uid}`,
      error: error?.message,
    });
  }

  return children;
}
